import Element from 'element-ui'
import { i18n } from './i18n'

export default {
  install (Vue) {
    Vue.use(Element, {
      i18n: (key, value) => i18n.t(key, value)
    })
  }
}
